function setRem () {
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
    const htmlDom = document.getElementsByTagName('html')[0]
    // 除以20在不同屏幕计算误差更小
    htmlDom.style.fontSize= htmlWidth / 20 + 'px'
}
setRem()
window.onresize = function () {
   setRem()
}